const mutationTypes = {
  SET_VERSIONS: 'SET_VERSIONS',
  REPLACE_VERSION: 'REPLACE_VERSION',
  ADD_PREVIEW_SHEET: 'ADD_PREVIEW_SHEET',
  RESET_PREVIEWS: 'RESET_PREVIEWS',
  RESET_VERSIONS: 'RESET_VERSIONS',
  CLOSE_PREVIEW_SHEET: 'CLOSE_PREVIEW_SHEET',
  DELETE_VERSION: 'DELETE_VERSION',
}

const actionTypes = {
  FETCH_VERSIONS: 'FETCH_VERSIONS',
  ADD_PREVIEW_SHEET: 'ADD_PREVIEW_SHEET',
  CREATE_VERSION: 'CREATE_VERSION',
  UPDATE_VERSION: 'UPDATE_VERSION',
  DELETE_VERSION: 'DELETE_VERSION',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/SurveyVersionsTypes.js